<div
  class="root"
  [class.box-layout]="useBoxLayout"
  [@slide]="{
    value: animationState,
    params: {
      closedDesktopHeight: closedDesktopHeight,
      closedMobileHeight: closedMobileHeight,
      time: time
    }
  }"
>
  <div
    class="top-content-container"
    [class.box-layout]="useBoxLayout"
    (click)="handleClick()"
  >
    <ng-content select="[topContent]"></ng-content>

    <div class="arrow" [class.rotate]="expanded" [class.margin-right]="!useBoxLayout">
      <app-lucide-icon 
        [iconName]="'chevron-down'"
        [size]="32"
      ></app-lucide-icon>
    </div>
  </div>

  <div
    *ngIf="displayBottomContent"
    class="bottom-content-container"
    [class.box-layout]="useBoxLayout"
  >
    <ng-content select="[bottomContent]"></ng-content>
  </div>
</div>
